// Cave84 — 404 (Phase 0 Day 3)
// Catches any unknown URL inside the authenticated shell.

import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="max-w-2xl mx-auto px-6 py-20 text-center">
      <p className="smallcaps text-text-tertiary mb-3">404</p>
      <h1 className="display text-5xl tracking-tight mb-4">Not found</h1>
      <p className="text-text-secondary mb-8">
        The page you were looking for doesn&apos;t exist (yet).
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-border-medium bg-surface-2 hover:bg-surface-3 hover:border-border-strong transition-colors text-sm text-text-primary"
      >
        Back to dashboard
      </Link>
    </section>
  );
}
